import styled from 'styled-components';
import { Image } from 'semantic-ui-react';

interface IStyledProps {
  isSelected: boolean;
  isMainAvatar?: boolean;
}

export const ChannelAvatar = styled.div`
  position: relative;
  font-size: 16px;
  text-transform: uppercase;
  color: white;
  width: ${(props: IStyledProps) => (props.isSelected ? '44px' : '36px')};
  height: ${(props: IStyledProps) => (props.isSelected ? '44px' : '36px')};
  margin: ${(props: IStyledProps) =>
    props.isSelected
      ? props.isMainAvatar
        ? '8px 8px 7px 8px'
        : '8px'
      : props.isMainAvatar
        ? '12px 12px 11px 12px'
        : '12px'};
  background-color: #4c5e70;
  border-radius: 24px;
  text-align: center;
  cursor: pointer;
  border: ${(props: IStyledProps) =>
    props.isSelected ? '4px solid white' : ''};
  box-shadow: ${(props: IStyledProps) =>
    props.isSelected ? '0 0 10px 0 rgba(0, 0, 0, 0.3)' : ''};
`;

export const AvatarImage = styled(Image)`
  &&& {
    width: 36px;
    height: 36px;
  }
`;

export const BadgeContainer = styled.div`
  color: #fff;
  background: #ff625a;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  bottom: -2px;
  right: -2px;
  z-index: 99;
  font-size: 10px;
`;
